/* Conscomer — Cotizador (metros lineales y metros cuadrados) */
(function () {
  'use strict';

  if (window.cotizadorLoaded) return;
  window.cotizadorLoaded = true;

  function ceilSeguro(valor) {
    var redondeado = Math.round(valor * 1e6) / 1e6;
    return Math.ceil(redondeado);
  }

  function formatear(n) {
    return (Math.round(n * 100) / 100).toFixed(2);
  }

  function pluralizar(unidad, cantidad) {
    if (cantidad === 1) return unidad;
    return unidad + 's';
  }

  function setup(container) {
    if (container.dataset.cotizadorReady === 'true') return;
    container.dataset.cotizadorReady = 'true';

    var cobertura = parseFloat(container.dataset.cobertura);
    var unidad = container.dataset.unidad || 'pieza';
    var unidadMedida = container.dataset.unidadMedida || 'm';
    var producto = container.dataset.producto || 'este producto';
    var quantityTargetId = container.dataset.quantityTarget || '';
    var whatsappNumero = container.dataset.whatsapp || '';
    var emailDestino = container.dataset.email || '';

    if (!isFinite(cobertura) || cobertura <= 0) return;

    var input = container.querySelector('[data-cotizador-input]');
    var errorEl = container.querySelector('.cotizador__error');
    var resultEl = container.querySelector('[data-cotizador-result]');
    var qtyEl = container.querySelector('[data-cotizador-qty]');
    var unitEl = container.querySelector('[data-cotizador-unit]');
    var coberturaEl = container.querySelector('[data-cotizador-cobertura]');
    var sobranteEl = container.querySelector('[data-cotizador-sobrante]');
    var waEl = container.querySelector('[data-cotizador-whatsapp]');
    var emailEl = container.querySelector('[data-cotizador-email]');

    if (!input) return;

    function mostrarError(msg) {
      if (errorEl) {
        errorEl.textContent = msg;
        errorEl.hidden = false;
      }
      if (resultEl) resultEl.hidden = true;
    }

    function limpiarError() {
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    }

    function ocultarResultado() {
      if (resultEl) resultEl.hidden = true;
    }

    function sincronizarCantidad(piezas) {
      if (!quantityTargetId) return;
      var target = document.getElementById(quantityTargetId);
      if (!target) return;

      var max = parseInt(target.getAttribute('max'), 10);
      var cantidad = piezas;
      if (isFinite(max) && max > 0 && cantidad > max) cantidad = max;

      target.value = cantidad;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }

    /* Construye el texto que se enviará por WhatsApp / correo */
    function construirMensaje(datos) {
      var lineas = [
        'Hola, me interesa cotizar el siguiente producto:',
        '',
        'Producto: ' + producto,
        'Necesito cubrir: ' + datos.solicitado + ' ' + unidadMedida,
        'Piezas necesarias: ' + datos.piezas + ' ' + datos.unidadPlural,
        'Cobertura total: ' + datos.coberturaTotal + ' ' + unidadMedida,
        'Sobrante estimado: ' + datos.sobrante + ' ' + unidadMedida,
        '',
        '¿Me pueden dar precio y disponibilidad?'
      ];
      return lineas.join('\n');
    }

    function actualizarBotones(datos) {
      var mensaje = construirMensaje(datos);

      if (waEl && whatsappNumero) {
        waEl.setAttribute(
          'href',
          'https://wa.me/' + whatsappNumero + '?text=' + encodeURIComponent(mensaje)
        );
      }

      if (emailEl && emailDestino) {
        var asunto = 'Cotización: ' + producto;
        var gmailUrl =
          'https://mail.google.com/mail/?view=cm&fs=1' +
          '&to=' + encodeURIComponent(emailDestino) +
          '&su=' + encodeURIComponent(asunto) +
          '&body=' + encodeURIComponent(mensaje);
        emailEl.setAttribute('href', gmailUrl);
      }
    }

    function calcular() {
      var raw = input.value.trim();

      if (raw === '') {
        limpiarError();
        ocultarResultado();
        return;
      }

      var solicitado = parseFloat(raw);

      if (isNaN(solicitado) || !isFinite(solicitado)) {
        mostrarError('Escribe una cantidad válida.');
        return;
      }

      if (solicitado <= 0) {
        mostrarError('La cantidad debe ser mayor que cero.');
        return;
      }

      limpiarError();

      var piezas = ceilSeguro(solicitado / cobertura);
      if (piezas < 1) piezas = 1;

      var coberturaTotal = piezas * cobertura;
      var sobrante = coberturaTotal - solicitado;
      if (sobrante < 0) sobrante = 0;

      var unidadPlural = pluralizar(unidad, piezas);

      if (qtyEl) qtyEl.textContent = piezas;
      if (unitEl) unitEl.textContent = unidadPlural;
      if (coberturaEl) coberturaEl.textContent = formatear(coberturaTotal);
      if (sobranteEl) sobranteEl.textContent = formatear(sobrante);

      actualizarBotones({
        solicitado: formatear(solicitado),
        piezas: piezas,
        unidadPlural: unidadPlural,
        coberturaTotal: formatear(coberturaTotal),
        sobrante: formatear(sobrante)
      });

      if (resultEl) resultEl.hidden = false;

      sincronizarCantidad(piezas);
    }

    input.addEventListener('input', calcular);
  }

  function init(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var nodes = root.querySelectorAll('[data-cotizador]');
    Array.prototype.forEach.call(nodes, setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
})();